import {
  collectExternalReferences,
  THIS_EXPR,
} from '@angular/compiler/src/output/output_ast';
import { ToastrService } from 'ngx-toastr';
import { StudyMaterialActivityHistory } from 'src/app/Models/StudyMaterial';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as $ from 'jquery';
import { VSubject } from 'src/app/Validators/Validators';
import { Router, ActivatedRoute } from '@angular/router';
import { AppOfflineStore } from '../../../app.offlineService';
import { Injectable } from '@angular/core';
import { combineLatest, forkJoin, Subject } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { ContentReviewcommentsComponent } from '../content-reviewcomments/content-reviewcomments.component';

import {
  Component,
  OnInit,
  Inject,
  AfterViewInit,
  Directive,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnDestroy,
  ChangeDetectionStrategy,
  AfterViewChecked,
} from '@angular/core';

// import { number } from 'ngx-custom-validators/src/app/number/validator';
import { ContentManagementService } from '../../../Services/content-management/content-management.service';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssignStudymaterialModalComponent } from '../assign-studymaterial-modal/assign-studymaterial-modal.component';
import { ContentManagementNavigatorComponent } from '../../master/content-management-navigator/content-management-navigator.component';
import { StudyUnitDisplayOrderComponent } from '../study-unit-display-order/study-unit-display-order.component';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { ContentAddEditStudymaterialComponent } from '../content-add-edit-studymaterial/content-add-edit-studymaterial.component';
import { StudyUnitMainTopicDisplayOrderComponent } from '../study-unit-main-topic-display-order/study-unit-main-topic-display-order.component';
import { CourseMainTopicAddEditComponent } from '../course-main-topic-add-edit/course-main-topic-add-edit.component';
import { AssignPracticeQuestionStudyMaterialComponent } from '../../question-management/assign-practice-question-study-material/assign-practice-question-study-material.component';
import { ContentManagementCloneSubjectSelectorComponent } from '../content-management-clone-subject-selector/content-management-clone-subject-selector.component';
import {
  IGetStudyUnitToCloneParams,
  IPerformStudyMaterialCloningParams,
} from '../../../Services/content-management/content-management.service';

interface ICloneStudyUnitRow {
  majorTopicId: number;
  majorTopicName: string;
  fromStudyUnitId: number | string;
  fromStudyUnitName: string;
  toStudyUnitId: number | string;
  toStudyUnitName: string;
  selected: boolean;
  displayOrder: number;
}

interface ICloneTopicGroup {
  majorTopicId: number;
  majorTopicName: string;
  rows: ICloneStudyUnitRow[];
}

@Component({
  selector: 'app-content-management-tree',
  templateUrl: './content-management-tree.component.html',
  styleUrls: ['./content-management-tree.component.css'],
})
export class ContentManagementTreeComponent implements OnInit {
  private readonly practiceQuestionPlaceholderStudyMaterialId = 0;

  Close: Subject<any> = new Subject();
  Replace: Subject<any> = new Subject();
  Close1: Subject<any> = new Subject();
  Replace1: Subject<any> = new Subject();
  Closeclear: Subject<any> = new Subject();
  Replaceclear: Subject<any> = new Subject();
  lanuage: any;
  StudyMaterialModel: any;
  courseId: number;
  ExamAgencyId: number;
  @Input() MajorTopic: MajorTopic[] = [];

  enableedit: boolean = true;
  Editsubjectflag = false;
  Addnewsubject = true;
  QuestionListflag: boolean = false;
  AddQuestionflag: boolean = false;
  ScreenName1: any;
  eventid: any;
  ExamAgencyName: string = '';
  CourseName: string = '';
  ExamYear: string = '';
  currentRoute: string = '';
  cloneSelection: any = null;
  cloneSubjectName: string = '';
  cloneTopicGroups: ICloneTopicGroup[] = [];
  cloneRowsLoaded = false;
  selectedCloneRowKey: string | null = null;
  @ViewChild('contentCmp') contentCmp?: ContentAddEditStudymaterialComponent;

  constructor(
    private cdr: ChangeDetectorRef,
    public datepipe: DatePipe,
    public service: ContentManagementService,
    private toastr: ToastrService,
    public appser: AppOfflineStore,
    public Mothertongue: AppOfflineStore,
    private fb: FormBuilder,
    public Activeroute: ActivatedRoute,
    public router: Router,
    private modalService: NgbModal
  ) {
    combineLatest([
      this.Activeroute.queryParams,
      this.Activeroute.params,
    ]).subscribe(([a, b]) => {
      this.ScreenName = b.ScreenName;
      const extracted = this.extractBetween(
        this.router.url, // Assuming this.route.url gives the full URL
        '/Content',
        '/' + this.ScreenName.split(' ')[0]
      );
      if (a['c_id']) {
        this.courseId = a['c_id']; // Retrieve the year query parameter
        this.ExamAgencyName = a['eA_Name'];
        this.CourseName = a['c_Name'];
        this.ExamYear = a['eY_Name'];
        this.ExamAgencyId = +a['eA_Id'];
      }
      this.service.setQueryParams({
        c_id: a['c_id'],
        eA_Name: a['eA_Name'],
        c_Name: a['c_Name'],
        eY_Name: a['eY_Name'],
        eA_Id: a['eA_Id'],
      });
      this.currentRoute = extracted;
      this.MajorTopic = [];
      this.getsubject(null, null);
      this.selectedsubject = '0';
      if (this.ScreenName !== 'CLONE') {
        this.cloneSelection = null;
        this.cloneSubjectName = '';
        this.cloneTopicGroups = [];
        this.cloneRowsLoaded = false;
        this.selectedCloneRowKey = null;
      }
    });
    this.lanuage = this.appser.dataStore[0].Language;
  }

  ngOnInit() {
    this.getsubject(null, null);
    this.getCode();
    this.getStatus();
    this.ScreenName1 = this.Activeroute.snapshot.paramMap.get('ScreenName');

    // Auto-open clone selector when on CLONE route
    if (this.ScreenName === 'CLONE') {
      setTimeout(() => {
        this.openCloneSelector();
      }, 300);
    }
  }

  get Note(){
    if(this.ScreenName1 === 'STUDY UNIT' || this.ScreenName1 === 'Display Order'){
    return 'This screen is to create Study Units/Lessons and select topics related to them. To create Study materials, go to Add/Edit Study Material'
    }else if(this.ScreenName1==='STUDY UNIT2' && !this.courseId){
      return 'To work on Study Material, please select a course first.'
    }
    else{
      return '';
    }
  }
  getAnchorLabel(param: string): string {
    switch (param) {
      case 'STUDY UNIT':
        return 'Add/Edit Study Unit (Module /Lesson)';
      case 'Display Order':
        return 'Study Unit (Module /Lesson) Display Order';
      case 'Main Topics':
        return 'Study Unit (Module /Lesson) Main Topics';
      case 'STUDY UNIT2':
        return 'Add Content (Study Material)';
      case 'CLONE':
        return 'Clone Study Unit and Study Material';
      case 'STUDY UNIT REPORT':
        return 'Study Unit Report';
      case 'WIP':
        return 'WIP';
      case 'Approved':
        return 'Approved';
      case 'Defer':
        return 'Deferred';
      case 'Rejected':
        return 'Rejected';
      case 'Rework':
        return 'Rework';
      case 'Under Review':
        return 'Under Review';
      case 'Submitted':
        return 'Submitted';
      default:
        return '';
    }
  }

  refreshPage() {
    location.reload();
  }

  extractBetween(url: string, start: string, end: string): string {
    // Find the start index (end of "/Content")
    const startIndex = url.indexOf(start) + start.length;

    // Find the end index (start of "/STUDY")
    const endIndex = url.indexOf(end);

    // Extract the substring between the two
    return endIndex > startIndex
      ? url.substring(startIndex, endIndex).trim()
      : '';
  }

  open() {
    // Check if ScreenName is CLONE

      const modalRef = this.modalService.open(
        ContentManagementNavigatorComponent,
        { size: 'md', backdrop: 'static', centered: true }
      );
      const route = '/Content' + this.currentRoute;
      modalRef.componentInstance.route = route;
      modalRef.componentInstance.param = this.ScreenName;

  }

  openCloneSelector() {
    const modalRef = this.modalService.open(
      ContentManagementCloneSubjectSelectorComponent,
      { size: 'md', backdrop: 'static', centered: true }
    );
    const route = '/Content' + this.currentRoute;
    modalRef.componentInstance.route = route;
    modalRef.componentInstance.param = this.ScreenName;
    modalRef.componentInstance.toCourseId = this.courseId;
    modalRef.componentInstance.initialSelection = this.cloneSelection;

    modalRef.result.then(
      (result) => {
        this.cloneSelection = result;
        this.cloneSubjectName = result?.subjectName || result?.subject?.Name || '';
        this.selectedsubject = result?.subjectId || result?.subjectCode || '0';
        this.selectedCloneRowKey = null;
        this.cloneTopicGroups = [];
        this.cloneRowsLoaded = false;
        if(this.cloneSubjectName){
          this.loadCloneStudyUnits()
        }
      },
      (dismissReason) => {
        // Handle dismissal
        console.log('Clone Selection Dismissed:', dismissReason);
      }
    );
  }

  loadCloneStudyUnits() {
    if (!this.cloneSelection?.subjectId || !this.courseId || !this.cloneSelection?.courseId) {
      this.cloneTopicGroups = [];
      this.cloneRowsLoaded = false;
      return;
    }

    const fromCourseId = Number(this.cloneSelection.year?.Code);
    const toCourseId = Number(this.courseId);
    if (fromCourseId && toCourseId && fromCourseId === toCourseId) {
      this.cloneTopicGroups = [];
      this.cloneRowsLoaded = false;
      this.toastr.warning('Source and target course cannot be the same for cloning.', 'Warning');
      return;
    }

    const payload: IGetStudyUnitToCloneParams = {
      FromCourseID: +this.cloneSelection.year?.Code,
      ToCourseID: +this.courseId,
      SubjectID: this.cloneSelection.subjectId,
    };

    this.service.GetStudyUnitToClone(payload).subscribe({
      next: (res: any[]) => {
        if (!res || res.length === 0) {
          this.cloneTopicGroups = [];
          this.toastr.warning('No Study Units available for cloning.', 'Info');
        } else {
          const rows = (res || []).map((item: any, idx: number) =>
            this.mapCloneRow(item, idx)
          );
          this.cloneTopicGroups = this.buildCloneGroups(rows);
        }
        this.cloneRowsLoaded = true;
      },
      error: (err: any) => {
        this.cloneTopicGroups = [];
        this.cloneRowsLoaded = true;
        const errorMsg = err?.error?.message || 'The course selected does not have the subject for which cloning is performed.';
        this.toastr.error(errorMsg, 'Error');
      },
    });
  }

  mapCloneRow(item: any, index: number): ICloneStudyUnitRow {
    return {
      majorTopicId: Number(item.Topic_Sort_Order ?? index + 1),
      majorTopicName: String(item.Topic_Name ?? ''),
      fromStudyUnitId: item.From_Study_Unit_ID,
      fromStudyUnitName: item.From_Study_Unit_Name,
      toStudyUnitId: item.To_Study_Unit_ID,
      toStudyUnitName: item.To_Study_Unit_Name,
      selected: false,
      displayOrder: Number(item.From_Study_Unit_Display_Order ?? index + 1),
    };
  }

  buildCloneGroups(rows: ICloneStudyUnitRow[]): ICloneTopicGroup[] {
    const groups = new Map<number, ICloneTopicGroup>();

    rows.forEach((row) => {
      if (!groups.has(row.majorTopicId)) {
        groups.set(row.majorTopicId, {
          majorTopicId: row.majorTopicId,
          majorTopicName: row.majorTopicName,
          rows: [],
        });
      }

      groups.get(row.majorTopicId)?.rows.push(row);
    });

    return Array.from(groups.values())
      .sort((a, b) => a.majorTopicId - b.majorTopicId)
      .map((group) => ({
        ...group,
        rows: [...group.rows].sort((a, b) => a.displayOrder - b.displayOrder),
      }));
  }

  getCloneRowKey(group: ICloneTopicGroup, row: ICloneStudyUnitRow): string {
    return `${group.majorTopicId}::${row.fromStudyUnitId}`;
  }

  isCloneRowDisabled(group: ICloneTopicGroup, row: ICloneStudyUnitRow): boolean {
    const rowKey = this.getCloneRowKey(group, row);
    return !!this.selectedCloneRowKey && this.selectedCloneRowKey !== rowKey;
  }

  isCloneActionEnabled(): boolean {
    return !!this.selectedCloneRowKey;
  }

  onCloneRowSelectionChange(
    group: ICloneTopicGroup,
    row: ICloneStudyUnitRow,
    event: Event
  ) {
    const checked = (event.target as HTMLInputElement)?.checked;
    const rowKey = this.getCloneRowKey(group, row);

    if (checked) {
      this.selectedCloneRowKey = rowKey;
      this.cloneTopicGroups.forEach((topicGroup) => {
        topicGroup.rows.forEach((topicRow) => {
          const currentKey = this.getCloneRowKey(topicGroup, topicRow);
          topicRow.selected = currentKey === rowKey;
        });
      });
    } else {
      row.selected = false;
      this.selectedCloneRowKey = null;
      this.cloneTopicGroups.forEach((topicGroup) => {
        topicGroup.rows.forEach((topicRow) => {
          topicRow.selected = false;
        });
      });
    }
  }

  clearCloneSelection() {
    this.selectedCloneRowKey = null;
    this.cloneTopicGroups.forEach((group) => {
      group.rows.forEach((row) => {
        row.selected = false;
      });
    });
  }

  proceedClone() {
    const selectedRows = this.cloneTopicGroups.reduce(
      (acc: ICloneStudyUnitRow[], group: ICloneTopicGroup) => {
        const rows = group.rows.filter((row: ICloneStudyUnitRow) => row.selected);
        return acc.concat(rows);
      },
      [] as ICloneStudyUnitRow[]
    );

    if (!selectedRows.length) {
      this.toastr.warning('Please select at least one Study Unit to clone.');
      return;
    }

    const invalidRows = selectedRows.filter((row) => !row.fromStudyUnitId);

    if (invalidRows.length > 0) {
      this.toastr.error('Source Study Unit is missing for one or more selected rows.', 'Error');
      return;
    }

    const requests = selectedRows.map((row) => {
      const payload: IPerformStudyMaterialCloningParams = {
        FromCourseID: +this.cloneSelection.year?.Code,
        FromStudyUnitID: Number(row.fromStudyUnitId),
        ToCourseID: +this.courseId,
        ToStudyUnitID:
          row.toStudyUnitId === null || row.toStudyUnitId === undefined || row.toStudyUnitId === ''
            ? null
            : Number(row.toStudyUnitId),
      };
      return this.service.PerformStudyMaterialCloning(payload);
    });

    forkJoin(requests).subscribe({
      next: (res:any) => {
        console.log(res)
        if (res[0].status){
        this.toastr.success('Study Material cloning completed successfully.', 'Success');
        this.clearCloneSelection();
        this.loadCloneStudyUnits();
        }else{
        this.toastr.error(res[0].message, 'Error');

        }
      },
      error: (err: any) => {
        const errorMsg = err?.error?.message || 'Failed to clone selected Study Materials.';
        this.toastr.error(errorMsg, 'Error');
      },
    });
  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }
  getstatus: any;
  getStatus() {
    this.service.GetCode({ Tablename: 'Study_Material_Status_Type' }).subscribe(
      (i: any) => {
        this.getstatus = i;

        // }).catch((e:any)=>{
        //   this.getstatus=null;
        // });
      },
      (error) => {
        console.log(error);
      }
    );
  }
  RefreshActivity() {
    let data = {
      target: {
        value: this.selectedsubject,
      },
    };
    if (
      this.selectedsubject != '0' &&
      this.selectedsubject != null &&
      this.selectedsubject !== ''
    ) {
      this.SelectSubject(data);
    }
  }

  subject: any;
  getsubject(data: any, d: any) {
    let ID: Number = 0;
    if (data != null) {
      ID = Number(data.ID);
    }
    let list: any = {};
    list['currentNodeID'] = ID;
    list['screenName'] = data ? 'STUDY MATERIAL' : 'STUDY UNIT';
    list['childRecordStatus'] = 'ALL';
    list['CalledFrom'] = `STUDY UNIT@${this.courseId}` || 'STUDY UNIT';
    console.log(this.ScreenName,'screen Name');

    // if (this.ScreenName === 'STUDY UNIT' || this.ScreenName === 'Display Order'  || this.ScreenName === 'STUDY UNIT2'){
    //   list['CalledFrom'] = `STUDY UNIT@${this.courseId}` || 'STUDY UNIT';
    // }else{
    //   list['CalledFrom'] = this.courseId || null ;
    // }
    // list['courseId'] = 'Content';
    this.service.getSubjectTree(list).subscribe(
      (i: any) => {
        this.subject = i;
        // }).catch((e:any)=>{
        //   this.subject=null;
        // }
        // )
      },
      (error) => {
        console.log(error);
      }
    );
  }




  selectedsubject: any = 0;
  studyUnitPracticeQuestionReport: any[] = [];

  SelectSubject(data: any) {
    this.selectedsubject = data.target.value;
    this.FromDate = null;
    this.ToDate = null;
    this.InitialLoadFlag = 'Y';
    if (this.ScreenName === 'Display Order') {
      this.SubjectDisplayOrder();
    }
    if (this.ScreenName === 'Report') {
      this.getSubjectReport();
    }
    if (this.ScreenName === 'Main Topics') {
      this.MainCourseDisplayOrder();
    }
    if(this.ScreenName === 'CLONE'){

    }
    if (this.ScreenName !== 'Display Order' && this.ScreenName !== 'Report' && this.ScreenName !== 'CLONE') {
      this.getsubjectData(data.target.value, 'MT', null);
      this.getActivityhistory(data.target.value);
    }
  }

  getSubjectReport(){
    const subjectId = Number(this.selectedsubject);
    if (!subjectId || !this.courseId) {
      this.studyUnitPracticeQuestionReport = [];
      return;
    }

    const payload = {
      CourseID: Number(this.courseId),
      SubjectID: subjectId,
    };

    this.service.GetStudyUnitPracticeQuestionCount(payload).subscribe(
      (response: any[]) => {
        this.studyUnitPracticeQuestionReport = response || [];
      },
      (error: any) => {
        console.log(error);
        this.studyUnitPracticeQuestionReport = [];
      }
    );
  }

  openAssignPracticeQuestion(row: any) {
    const studyMaterialId = Number(
      row?.Study_Material_Id ??
        row?.Study_Material_ID ??
        this.practiceQuestionPlaceholderStudyMaterialId
    );

    const modalRef = this.modalService.open(
      AssignPracticeQuestionStudyMaterialComponent,
      {
        centered: true,
        size: 'lg',
        windowClass: 'custom-modal-width-relation',
      }
    );

    modalRef.componentInstance.studyMaterial = {
      // Placeholder ID is used until backend starts returning Study_Material_Id.
      Study_Material_Id: studyMaterialId,
    };
  }

  resolveMajorTopicSubject(subjectId: number, callback: (res: any) => void) {
    if (!subjectId) {
      callback(null);
      return;
    }
    this.service.getsubjectById({ CurrentNodeSubjectID: Number(subjectId) }).subscribe({
      next: (res: any) => {
        if (
          !res ||
          res.Subject_Level_Type_Code === 'MT' ||
          res.Subject_Level_Type_Code === 'S' ||
          !res.Parent_Subject_Id
        ) {
          callback(res);
        } else {
          this.resolveMajorTopicSubject(res.Parent_Subject_Id, callback);
        }
      },
      error: () => callback(null),
    });
  }

  openEditStudyUnitFromReport(row: any) {
    const studyUnitId = Number(
      row?.Study_Unit_Id ?? row?.Study_Unit_ID ?? row?.ID ?? row?.StudyUnitID
    );

    if (!studyUnitId) {
      this.toastr.error('Study Unit details not available.');
      return;
    }

    const defaultSubjectId = Number(
      row?.Subject_Id ?? row?.Subject_ID ?? row?.Parent_Id ?? this.selectedsubject
    );

    const editItem = {
      ID: studyUnitId,
      Study_Unit_Id: studyUnitId,
      Parent_Id: defaultSubjectId,
      ...row,
    };

    this.StudyUnitEditList = editItem;

    this.service.GetStudyUnitSubject({ Study_Unit_Id: studyUnitId }).subscribe({
      next: (res: any) => {
        const masterList = res?.MasterList ?? [];
        const selectedSubject =
          masterList.find((e: any) => e.Selected_For_Current_Study_Unit_IND === 'Y') ??
          masterList[0];

        const topicSubjectId = Number(
          selectedSubject?.Subject_ID ?? selectedSubject?.Subject_Id ?? defaultSubjectId
        );

        if (topicSubjectId) {
          this.resolveMajorTopicSubject(topicSubjectId, (mtSubjectRes: any) => {
            const finalSubjectRes = mtSubjectRes || { Subject_Id: defaultSubjectId };
            this.subjectById = finalSubjectRes;
            this.Refresh = { dataID: finalSubjectRes.Subject_Id };
            this.EditStudyUnitflag = true;
          });
        } else {
          this.EditStudyUnitflag = true;
        }
      },
      error: () => {
        if (defaultSubjectId) {
          this.service
            .getsubjectById({ CurrentNodeSubjectID: Number(defaultSubjectId) })
            .subscribe({
              next: (res: any) => {
                this.subjectById = res;
                this.Refresh = { dataID: defaultSubjectId };
                this.EditStudyUnitflag = true;
              },
              error: (err: any) => {
                console.log(err);
                this.EditStudyUnitflag = true;
              },
            });
        } else {
          this.EditStudyUnitflag = true;
        }
      },
    });
  }

  openEditStudyMaterialFromReport(row: any) {
    const studyMaterialId = Number(
      row?.Study_Material_Id ??
        row?.Study_Material_ID ??
        row?.StudyMaterialID ??
        row?.ID
    );

    if (!studyMaterialId) {
      this.toastr.error('Study Material details not available.');
      return;
    }

    const studyUnitId = Number(
      row?.Study_Unit_Id ?? row?.Study_Unit_ID ?? row?.StudyUnitID
    );

    const defaultSubjectId = Number(
      row?.Subject_Id ?? row?.Subject_ID ?? row?.Parent_Id ?? this.selectedsubject
    );

    const materialData = {
      ...row,
      Study_Material_Id: studyMaterialId,
      Study_Unit_Id: studyUnitId || row?.Study_Unit_Id,
    };

    if (studyUnitId) {
      this.service.GetStudyUnitSubject({ Study_Unit_Id: studyUnitId }).subscribe({
        next: (res: any) => {
          const masterList = res?.MasterList ?? [];
          const selectedSubject =
            masterList.find((e: any) => e.Selected_For_Current_Study_Unit_IND === 'Y') ??
            masterList[0];

          const topicSubjectId = Number(
            selectedSubject?.Subject_ID ?? selectedSubject?.Subject_Id ?? defaultSubjectId
          );

          if (topicSubjectId) {
            this.resolveMajorTopicSubject(topicSubjectId, (mtSubjectRes: any) => {
              const finalSubjectRes = mtSubjectRes || { Subject_Id: defaultSubjectId };
              this.subjectById = finalSubjectRes;
              this.Refresh = { dataID: finalSubjectRes.Subject_Id };
              this.Editstudymaterial(materialData);
            });
          } else {
            this.Editstudymaterial(materialData);
          }
        },
        error: () => {
          if (defaultSubjectId) {
            this.service
              .getsubjectById({ CurrentNodeSubjectID: Number(defaultSubjectId) })
              .subscribe({
                next: (res: any) => {
                  this.subjectById = res;
                  this.Refresh = { dataID: defaultSubjectId };
                  this.Editstudymaterial(materialData);
                },
                error: (err: any) => {
                  console.log(err);
                  this.Editstudymaterial(materialData);
                },
              });
          } else {
            this.Editstudymaterial(materialData);
          }
        },
      });
    } else {
      this.Editstudymaterial(materialData);
    }
  }

  getvalue: any;
  ActivityHistorylist: any;
  status: any;
  FromDate: string | null;
  ToDate: string | null;
  QuestionStatus: string | null;
  StudyMaterialKeyword1: string | null;
  selectOperator: string | null;
  StudyMaterialKeyword2: string | null;
  OwnStudyMaterialInd: string;
  InitialLoadFlag: string;
  operator = [
    {
      Code: 'AND',
      Description: 'AND',
    },
    {
      Code: 'OR',
      Description: 'OR',
    },
    {
      Code: null,
      Description: '',
    },
  ];
  getActivityhistory(data: any) {
    var temp: StudyMaterialActivityHistory;
    if (this.Activeroute.snapshot.paramMap.get('ScreenName') == 'STUDY UNIT') {
      this.status = null;
    } else {
      this.status = this.ScreenName1;
    }
    let list: any = {
      Subject_ID: data,
      Study_Material_Status_Type_Code: this.status,
      From_Date: this.datepipe.transform(this.FromDate, 'MM/dd/yyyy'),
      To_Date: this.datepipe.transform(this.ToDate, 'MM/dd/yyyy'),
      InitialLoadInd: this.InitialLoadFlag,
      StudyMaterialKeyword1: this.StudyMaterialKeyword1,
      Operator: this.selectOperator,
      StudyMaterialKeyword2: this.StudyMaterialKeyword2,
      OwnStudyMaterialInd: this.OwnStudyMaterialInd,
    };
    this.StudyMaterialModel = list;
    this.service.GetActivityHistory(this.StudyMaterialModel).subscribe(
      (i: any) => {
        this.getvalue = i;
        this.ActivityHistorylist = this.getvalue.Data;
        console.log(this.ActivityHistorylist);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  ActivityHisotrypopupflag: boolean;
  ViewActivityHistory() {
    this.ActivityHisotrypopupflag = !this.ActivityHisotrypopupflag;
    //     if(this.ActivityHisotrypopupflag){
    //  this.getActivityhistory(this.selectedsubject);
    // }
  }

  SearchActivity() {
    // this.InitialLoadFlag='N';
    // this.getActivityhistory(this.selectedsubject);
    this.SearchQuestionModel();
  }

  FilterQuestion() {
    this.getActivityhistoryquestion(this.selectedsubject);
  }

  filtermodelpopup: boolean;
  FilterModelpopup() {
    this.filtermodelpopup = !this.filtermodelpopup;
    if (!this.Searchmodelpopup) {
      this.SearchQuestionModel();
    }
  }

  getFilterlist: any;
  getFilterResponse: any;
  finalkeyword1: string;
  statustype: string | null;
  getActivityhistoryquestion(data: any) {
    if (!this.status) {
      this.status = null;
    }
    if (!this.selectOperator) {
      this.selectOperator = null;
    }
    if (this.OwnQuestionInd) {
      this.OwnStudyMaterialInd = 'Y';
    } else {
      this.OwnStudyMaterialInd = 'N';
    }

    let list: any = {
      Subject_ID: data,
      Study_Material_Status_Type_Code: this.status,
      From_Date: this.datepipe.transform(this.FromDate, 'MM/dd/yyyy'),
      To_Date: this.datepipe.transform(this.ToDate, 'MM/dd/yyyy'),
      InitialLoadInd: 'N',
      StudyMaterialKeyword1: this.StudyMaterialKeyword1,
      Operator: this.selectOperator,
      StudyMaterialKeyword2: this.StudyMaterialKeyword2,
      OwnStudyMaterialInd: this.OwnStudyMaterialInd,
    };

    // this.SpinnerService.show();
    this.service.GetActivityHistory(list).subscribe(
      (i: any) => {
        this.getFilterResponse = i;

        if (this.getFilterResponse.Message == 'Success') {
          this.getFilterlist = this.getFilterResponse.Data;
          console.log(this.getFilterlist);

          if (this.getFilterlist.length > 0) {
            if (this.Searchmodelpopup) {
              this.SearchQuestionModel();
            }
            this.FilterModelpopup();
          } else {
            this.toastr.warning('Study Material does not exist');
          }
        } else {
          this.toastr.error(this.getFilterResponse.Message);
        }
        // this.SpinnerService.hide();
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  Searchmodelpopup: boolean;
  SearchQuestionModel() {
    this.Searchmodelpopup = !this.Searchmodelpopup;
    this.Clear();
  }

  Clear() {
    this.FromDate = null;
    this.ToDate = null;
    this.InitialLoadFlag = 'N';
    this.status = null;
    this.StudyMaterialKeyword1 = null;
    this.selectOperator = null;
    this.StudyMaterialKeyword2 = null;
    this.OwnQuestionInd = false;
    // this.error={isError:false,errorMessage:''};
    // this.Descriptionvaluelength=0;
  }
  OwnQuestionInd: boolean;
  ClickOwnQuestionInd() {
    this.OwnQuestionInd = !this.OwnQuestionInd;
  }

  getcodes: any;
  getCode() {
    this.service.GetCode({ Tablename: 'SUBJECT_LEVEL_TYPE' }).subscribe(
      (i: any) => {
        this.getcodes = i;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  parentid: any;
  breadcrumbID: any = [];
  Dynamic: any;

  Descriptionvalue: any;
  question: any;
  ScreenName: any;

  getsubjectData(
    data: any,
    name: any,
    M: any,
    C?: any,
    SC1?: any,
    SC2?: any,
    SC3?: any,
    SC4?: any,
    SC5?: any
  ) {
    let majortopicsarr: any = [];
    if (this.MajorTopic != null) {
      majortopicsarr = this.MajorTopic;
    }
    this.getsubjectId(data);
    //this.getBreadcrumbDetails(data);
    let ID: Number = 0;
    if (data != null) {
      ID = Number(data);
    }
    this.ScreenName = this.Activeroute.snapshot.paramMap.get('ScreenName');

    let list: any = {};
    if (this.Activeroute.snapshot.paramMap.get('ScreenName') == 'STUDY UNIT') {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY UNIT';
      list['childRecordStatus'] = 'ALL';
       list['CalledFrom'] = `STUDY UNIT@${this.courseId}` || 'STUDY UNIT';

    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'STUDY UNIT2'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'ALL';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL' ;
    } else if (this.Activeroute.snapshot.paramMap.get('ScreenName') == 'WIP') {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'WIP';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Approved'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'Approved';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Defer'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'Defer';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rejected'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'Rejected';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rework'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'Rework';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Under Review'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'Under Review';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Submitted'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'Submitted';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else {
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'ALL';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    }

    this.service.getSubjectTree(list).subscribe(
      (i: any) => {
        if (name == 'MT') {
          this.MajorTopic = i;

          this.subject.forEach((i: { ID: any }) => {
            if (Number(i.ID) === Number(ID)) {
            }
          });
        } else if (name == 'C') {
          if (this.MajorTopic[M].Data !== null) this.MajorTopic[M].Data = null;
          else {
            this.MajorTopic[M].Data = i;
          }
        } else if (name == 'SC1') {
          if (this.MajorTopic[M].Data[C].Data !== null)
            this.MajorTopic[M].Data[C].Data = null;
          else {
            this.MajorTopic[M].Data[C].Data = i;
          }
        } else if (name == 'SC2') {
          if (this.MajorTopic[M].Data[C].Data[SC1].Data !== null)
            this.MajorTopic[M].Data[C].Data[SC1].Data = null;
          else {
            this.MajorTopic[M].Data[C].Data[SC1].Data = i;
          }
        } else if (name == 'SC3') {
          if (this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data !== null)
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data = null;
          else {
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data = i;
          }
        } else if (name == 'SC4') {
          if (
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data !==
            null
          )
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data =
              null;
          else {
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data = i;
          }
        } else if (name == 'SC5') {
          if (
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4]
              .Data !== null
          )
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[
              SC4
            ].Data = null;
          else {
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[
              SC4
            ].Data = i;
          }
        } else if (name == 'SC6') {
          if (
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4]
              .Data[SC5].Data !== null
          )
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[
              SC4
            ].Data[SC5].Data = null;
          else {
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[
              SC4
            ].Data[SC5].Data = i;
          }
        }

        //   }).catch((e:any)=>{
        //   this.subject=null;
        // }
        // )
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  statusvalidate: any;
  DefaultStatus: any;
  subjectById: any;
  getsubjectId(data: any) {
    let ID: Number = 0;
    try {
      if (data > 0 || data == null) {
        ID = Number(data);
      } else if (Number(data.ID) > 0) {
        ID = Number(data.ID);
      }
    } catch {}
    this.service.getsubjectById({ CurrentNodeSubjectID: Number(ID) }).subscribe(
      (i: any) => {
        this.subjectById = i;
        if (this.getsubjectdetails) {
          this.StudyUnitPopup();
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  addEditCourseMainTopic(MajorTopic:any){
     const modalRef = this.modalService.open(CourseMainTopicAddEditComponent, {
          centered: true,
          size: 'lg',
          backdrop: 'static'
        });
        modalRef.componentInstance.item= MajorTopic
        modalRef.componentInstance.Screen ='STUDYUNIT'
        modalRef.componentInstance.dataFromStudyUnit =MajorTopic
        modalRef.componentInstance.courseId = this.courseId
        modalRef.result.then(
          (result:any) => {
            console.log('Saved payload:', result);
            // handle saved result
            this.RefreshActivity()
          },
          (reason:any) => {
            console.log('Modal dismissed');
          }
        );
  }

  Refresh: any;
  getsubjectdetails: boolean;
  check: boolean = false;
  value: any;
  AddStudyUnit(
    data: any,
    name: any,
    M: any,
    C?: any,
    SC1?: any,
    SC2?: any,
    SC3?: any,
    SC4?: any,
    SC5?: any,
    SC6?: any
  ) {
    this.StudyUnitEditList = null;
    for (let item of this.getcodes) {
      if (item.Code == 'SCL1') item.Code = 'SC1';
      else if (item.Code == 'SCL2') item.Code = 'SC2';
      else if (item.Code == 'SCL3') item.Code = 'SC3';
      else if (item.Code == 'SCL4') item.Code = 'SC4';
      else if (item.Code == 'SCL5') item.Code = 'SC5';
      else if (item.Code == 'SCL6') item.Code = 'SC6';
      else item.Code;
      if (item.Code == name) {
        this.Descriptionvalue = item.Description;
      }
    }
    let ID: Number = 0;
    if (data != null) {
      ID = Number(data.ID);
    }
    let list: any = {};
    list['currentNodeID'] = ID;
    list['screenName'] = 'STUDY UNIT';
    list['childRecordStatus'] = 'ALL';
    list['CalledFrom'] = `STUDY UNIT@${this.courseId}` || 'STUDY UNIT';
    this.service
      .GetCourseStudyUnitSubjectToSelect$('', '', null)
      .subscribe((e) => {
        console.log(e);
      });
    this.service.getSubjectTree(list).subscribe((i: any) => {
      this.value = i;
      this.check = false;
      for (let v of this.value) {
        if (v.Study_Unit_Ind == 'N') {
          this.check = true;
          break;
        }
      }
      if (this.check) {
        this.Refresh = {
          dataID: data.Parent_Id,
          name: name,
          M: M,
          C: C,
          SC1: SC1,
          SC2: SC2,
          SC3: SC3,
          SC4: SC4,
          SC5: SC5,
          SC6: SC6,
        };
        this.getsubjectId(data.ID);
        this.getsubjectdetails = true;
        this.validclosebutton = false;
      } else {
        this.toastr.info('No Topic is available for a New Study Unit');
      }
    });
  }

  studymateriallist: any;
  StudymaterialFormvalue: any;
  contentpreview(data: any) {
    this.StudymaterialFormvalue = data.Formvalue;
    this.studymateriallist = data.StudyMateriallist;
    if (this.AddStudyMaterialflag) {
      this.AddStudyMaterialPopup();
    }

    this.previewpopup();
  }

  studymateriallist1: any;
  StudymaterialFormvalue1: any;
  contentreview(data: any) {
    this.StudymaterialFormvalue1 = data.Formvalue;
    this.studymateriallist1 = data.StudyMateriallist;

    if (this.AddStudyMaterialflag) {
      this.AddStudyMaterialPopup();
    }
    this.reviewpopup();
    if (
      data.StudyMateriallist.Study_Material_Status_Type_Code == 'Submitted' ||
      data.StudyMateriallist.Study_Material_Status_Type_Code == 'Under Review'
    ) {
      if (this.EditStudyMaterialflag) {
        this.EditStudyMaterialpopup();
        if (this.selectedsubject > 0) {
          this.getActivityhistory(this.selectedsubject);
        }
      }
    }
  }
  reviewpopupflag: boolean;
  reviewpopup() {
    this.reviewpopupflag = !this.reviewpopupflag;
  }
  CloseReviewContent() {
    this.reviewpopup();
    if (
      ContentReviewcommentsComponent.currentstudymaterialstatus
        .Study_Material_Status_Type_Code == 'Submitted' ||
      ContentReviewcommentsComponent.currentstudymaterialstatus
        .Study_Material_Status_Type_Code == 'Under Review'
    ) {
      this.Editstudymaterial(
        ContentReviewcommentsComponent.currentstudymaterialstatus
      );
    }

    console.log(
      ContentReviewcommentsComponent.currentstudymaterialstatus,
      'testglobal'
    );
  }
  previewpopupflag: boolean;
  previewpopup() {
    this.previewpopupflag = !this.previewpopupflag;
  }
  returnclosebutton(data: any) {
    if (this.previewpopupflag) {
      this.previewpopup();
    }
  }
  returnreviewclosebutton(data: any) {
    if (this.reviewpopupflag) {
      this.reviewpopup();
      if (
        ContentReviewcommentsComponent.currentstudymaterialstatus
          .Study_Material_Status_Type_Code == 'Submitted' ||
        ContentReviewcommentsComponent.currentstudymaterialstatus
          .Study_Material_Status_Type_Code == 'Under Review'
      ) {
        this.Editstudymaterial(
          ContentReviewcommentsComponent.currentstudymaterialstatus
        );
      }
      if (this.selectedsubject > 0) {
        this.getActivityhistory(this.selectedsubject);
      }

      console.log(
        ContentReviewcommentsComponent.currentstudymaterialstatus,
        'testglobal'
      );
    }
  }
  Closepreview() {
    this.previewpopup();
  }
  returnreviewpopup(data: any) {
    if (this.previewpopupflag) {
      this.Closepreview();
    }
    if (this.EditStudyMaterialflag) {
      this.EditStudyMaterialpopup();
      if (this.selectedsubject > 0) {
        this.getActivityhistory(this.selectedsubject);
      }
    }
    if (this.reviewpopupflag) {
      this.reviewpopup();
      if (this.selectedsubject > 0) {
        this.getActivityhistory(this.selectedsubject);
      }
    }
  }

  selectedstudyunit: any;
  studymaterialflag: boolean;
  getStudyMaterial(Value?: Number) {
    this.studymaterialflag = !this.studymaterialflag;

    if (this.studymaterialflag) {
      if (Value != null) {
        this.StudyMaterial(Value);
      }
    }
    if (!this.studymaterialflag) {
      this.selectedstudyunit = null;
      this.StudyMaterialresponse = null;
      if (this.CurrentlistId != Number(Value)) {
        if (Value != null) {
          this.StudyMaterial(Value);
        }
      }
    }
  }
  SubjectDisplayOrder() {
    if (this.selectedsubject == '0') {
      return; // Don't open modal if "Select Subject" is chosen
    }
    const modalRef = this.modalService.open(StudyUnitDisplayOrderComponent, {
      backdrop: 'static',
      keyboard: false,
      scrollable: true,
      windowClass: 'display-modal-width',
      size: 'lg',
    });
    modalRef.componentInstance.SubjectId = this.selectedsubject;
    modalRef.componentInstance.courseId = this.courseId;
    modalRef.result
      .then((result) => {
        this.selectedsubject = 0;
        console.log('Modal closed with result:', result);
        // Call a function to handle the result
      })
      .catch((reason) => {
        console.log('Modal dismissed:', reason);
      });
  }
    MainCourseDisplayOrder() {
    if (this.selectedsubject == '0') {
      return;
    }

    const modalRef = this.modalService.open(StudyUnitMainTopicDisplayOrderComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      scrollable: true,
      windowClass: 'display-modal-width',
      size: 'lg',
    });
    modalRef.componentInstance.SubjectId = this.selectedsubject;
    modalRef.componentInstance.courseId = this.courseId;
    modalRef.result
      .then((result) => {
        this.selectedsubject = 0;
      })
      .catch((reason) => {
        console.log('Modal dismissed:', reason);
      });
  }
  AssignStudyMaterial(StudyUnit: any) {
    const modalRef = this.modalService.open(AssignStudymaterialModalComponent, {
      backdrop: 'static',
      keyboard: false,
      scrollable: true,
      windowClass: 'custom-modal-width',
    });
    modalRef.componentInstance.StudyUnit = StudyUnit;
    // Listen for the preview event
    modalRef.componentInstance.editAssignMaterial.subscribe(
      (studymaterial: any) => {
        this.Editstudymaterial(studymaterial);
      }
    );
    modalRef.componentInstance.previewEvent.subscribe((studyMaterial: any) => {
      this.contentpreview(studyMaterial);
    });
  }
  CloseandRefreshlist(data: any) {
    if (this.AddStudyMaterialflag) {
      this.AddStudyMaterialPopup();
    }

    if (this.EditStudyMaterialflag) {
      this.EditStudyMaterialpopup();
      if (this.selectedsubject > 0) {
        this.getActivityhistory(this.selectedsubject);
      }
    }

    this.getStudyMaterial(this.CurrentstudyunitID);
  }

  SubjectlistID: any;
  StudyUnit: any;
  ShowSubjectlist(data: any) {
    this.SubjectlistID = data.ID;
    this.StudyUnit = data;
    let ID: Number = 0;
    if (data != null) {
      ID = Number(data.Parent_Id);
      this.service
        .getsubjectById({ CurrentNodeSubjectID: Number(ID) })
        .subscribe((i: any) => {
          this.subjectById = i;
          this.showsubjectlistpopup();
        });
    }
  }
  CloseSubject() {
    if (this.showsubjectlistflag) {
      this.showsubjectlistpopup();
    }
  }
  showsubjectlistflag: boolean;
  showsubjectlistpopup() {
    this.showsubjectlistflag = !this.showsubjectlistflag;
  }
  StudyMaterialresponse: any;
  Search: any;
  CurrentlistId: Number;
  StudyMaterial(data: any) {
    let ID: Number = 0;
    if (data != null) {
      ID = Number(data);
    }
    this.CurrentlistId = ID;

    let list: any = {};
    if (this.Activeroute.snapshot.paramMap.get('ScreenName') == 'STUDY UNIT') {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'ALL';
    } else if (this.Activeroute.snapshot.paramMap.get('ScreenName') == 'WIP') {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'WIP';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Approved'
    ) {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'Approved';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Defer'
    ) {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'Defer';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rejected'
    ) {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'Rejected';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rework'
    ) {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'Rework';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Under Review'
    ) {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'Under Review';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Submitted'
    ) {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'Submitted';
    } else {
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'ALL';
    }

    this.service.GetStudyMaterialList(list).subscribe(
      (i: any) => {
        this.Search = i;
        this.StudyMaterialresponse = this.Search.StudyMaterial;
        this.selectedstudyunit = ID;
        //  }).catch((e:any)=>{
        //    this.StudyMaterialresponse=e;
        //  }
        //  )
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  CurrentstudyunitID: any;
  CurrentstudyunitName: string = '';
  AddStudyMaterial(
    data: any,
    name: any,
    M: any,
    C?: any,
    SC1?: any,
    SC2?: any,
    SC3?: any,
    SC4?: any,
    SC5?: any,
    SC6?: any
  ) {
    this.CurrentstudyunitID = data.ID;
    this.CurrentstudyunitName = data?.Name || '';
    for (let item of this.getcodes) {
      if (item.Code == 'SCL1') item.Code = 'SC1';
      else if (item.Code == 'SCL2') item.Code = 'SC2';
      else if (item.Code == 'SCL3') item.Code = 'SC3';
      else if (item.Code == 'SCL4') item.Code = 'SC4';
      else if (item.Code == 'SCL5') item.Code = 'SC5';
      else if (item.Code == 'SCL6') item.Code = 'SC6';
      else item.Code;
      if (item.Code == name) {
        this.Descriptionvalue = item.Description;
      }
    }
    let ID: Number = 0;
    if (data != null) {
      ID = Number(data.Parent_Id);
      this.service
        .getsubjectById({ CurrentNodeSubjectID: Number(ID) })
        .subscribe((i: any) => {
          this.subjectById = i;
          this.Refresh = {
            dataID: data.Parent_Id,
            name: name,
            M: M,
            C: C,
            SC1: SC1,
            SC2: SC2,
            SC3: SC3,
            SC4: SC4,
            SC5: SC5,
            SC6: SC6,
          };
          this.AddStudyMaterialPopup();
        });
    }
  }
  StudyUnitEditList: any;
  subjectvalue: any;
  EditStudyUnit(
    data: any,
    name: any,
    M: any,
    C?: any,
    SC1?: any,
    SC2?: any,
    SC3?: any,
    SC4?: any,
    SC5?: any,
    SC6?: any
  ) {
    this.StudyUnitEditList = data;
    for (let item of this.getcodes) {
      if (item.Code == 'SCL1') item.Code = 'SC1';
      else if (item.Code == 'SCL2') item.Code = 'SC2';
      else if (item.Code == 'SCL3') item.Code = 'SC3';
      else if (item.Code == 'SCL4') item.Code = 'SC4';
      else if (item.Code == 'SCL5') item.Code = 'SC5';
      else if (item.Code == 'SCL6') item.Code = 'SC6';
      else item.Code;
      if (item.Code == name) {
        this.Descriptionvalue = item.Description;
      }
    }
    let ID: Number = 0;
    if (data != null) {
      ID = Number(data.Parent_Id);
      this.service
        .getsubjectById({ CurrentNodeSubjectID: Number(ID) })
        .subscribe((i: any) => {
          this.subjectById = i;
          this.Refresh = {
            dataID: data.Parent_Id,
            name: name,
            M: M,
            C: C,
            SC1: SC1,
            SC2: SC2,
            SC3: SC3,
            SC4: SC4,
            SC5: SC5,
            SC6: SC6,
          };
          this.EditStudyUnitPopup();
        });
    }
  }

  StudyMaterialDetails: any;
  Editstudymaterial(data: any) {
    console.log(data, 'Edit study unit');
    this.CurrentstudyunitID =
      data?.Study_Unit_Id ??
      data?.Study_Unit_ID ??
      data?.StudyUnitID ??
      this.CurrentstudyunitID;
    this.CurrentstudyunitName =
      data?.Study_Unit_Name ||
      data?.StudyUnitName ||
      data?.Name ||
      this.getStudyUnitNameById(this.CurrentstudyunitID) ||
      this.CurrentstudyunitName;
    this.StudyMaterialDetails = data;
    if (this.ActivityHisotrypopupflag) {
      this.ViewActivityHistory();
    }
    if (this.filtermodelpopup) {
      this.FilterModelpopup();
    }
    if (this.Searchmodelpopup) {
      this.SearchQuestionModel();
    }

    this.EditStudyMaterialpopup();
  }

  private getStudyUnitNameById(studyUnitId: any): string {
    const targetId = Number(studyUnitId);
    if (!targetId || !this.MajorTopic?.length) {
      return '';
    }

    const stack = [...this.MajorTopic];
    while (stack.length) {
      const node = stack.pop();
      if (Number(node?.ID) === targetId) {
        return node?.Name || '';
      }
      if (node?.Data?.length) {
        stack.push(...node.Data);
      }
    }

    return '';
  }

  EditStudyMaterialflag: boolean;
  EditStudyMaterialpopup($event?: any) {
    this.EditStudyMaterialflag = !this.EditStudyMaterialflag;
  }

  CloseEditStudyMaterial(data: any) {
    if (this.EditStudyMaterialflag) {
      this.EditStudyMaterialpopup();
      if (this.selectedsubject > 0) {
        this.getActivityhistory(this.selectedsubject);
      }
    }
  }

  onCLose() {
    this.contentCmp?.OnClose();
  }

  CheckFormDirty(data: any) {}

  CloseStudyUnitSubject(data: any) {
    this.CloseSubject();
  }

  AddStudyMaterialflag: boolean;
  AddStudyMaterialPopup() {
    this.AddStudyMaterialflag = !this.AddStudyMaterialflag;
  }

  CloseStudyMaterial() {
    this.AddStudyMaterialflag = !this.AddStudyMaterialflag;
  }
  EditStudyUnitflag: boolean;
  EditStudyUnitPopup() {
    this.EditStudyUnitflag = !this.EditStudyUnitflag;
  }
  CloseEditStudyUnit() {
    this.EditStudyUnitflag = !this.EditStudyUnitflag;
  }
  AddStudyUnitflag: boolean;
  StudyUnitPopup() {
    this.AddStudyUnitflag = !this.AddStudyUnitflag;
  }
  CloseStudyUnit() {
    if (!this.validclosebutton) {
      this.getsubjectdetails = false;
      if (this.AddStudyUnitflag) {
        this.AddStudyUnitflag = !this.AddStudyUnitflag;
      }
    } else {
      this.toastr.error('Please Select Topics for Study Unit', '', {
        timeOut: ConstantVars.ToastErrorTimeout,
      });
    }
  }
  //StudyUnitSubject
  StudyUnitID: any;
  StudyUnitPopupflag: any;
  AddStudyUnitSubject(data: any) {
    this.StudyUnitID = data;
    if (this.AddStudyUnitflag) {
      this.StudyUnitTopicPopup();
    }
    if (this.EditStudyUnitflag) {
      this.EditStudyUnitTopic();
    }
  }
  validclosebutton: boolean = false;
  StudyUnitClose(data: any) {
    //this.getsubjectdetails=false;
    this.validclosebutton = data;
  }

  cancelbutton(data: any) {
    this.getsubjectdetails = false;
    if (this.AddStudyUnitflag) {
      this.StudyUnitPopup();
    }
    if (this.EditStudyUnitflag) {
      this.EditStudyUnitPopup();
    }
  }

  StudyUnitTopicPopup() {
    this.StudyUnitPopupflag = !this.StudyUnitPopupflag;
  }
  EditStudyUnitTopicflag: boolean;
  EditStudyUnitTopic() {
    this.EditStudyUnitTopicflag = !this.EditStudyUnitTopicflag;
  }

  CloseEditStudyUnitTopics() {
    this.getsubjectdetails = false;
    this.EditStudyUnitTopic();
  }

  CloseStudyUnitTopics() {
    this.getsubjectdetails = false;
    this.StudyUnitTopicPopup();
    //this.StudyUnitPopup();
  }

  CloseSUTopics(data: any) {
    if (this.AddStudyUnitflag) {
      this.CloseStudyUnitTopics();
    }
    if (this.EditStudyUnitflag) {
      this.CloseEditStudyUnitTopics();
    }
  }

  closeall(data: any) {
    this.getsubjectdetails = false;
    if (this.AddStudyUnitflag) {
      this.StudyUnitPopup();
    }
    if (this.StudyUnitPopupflag) {
      this.StudyUnitTopicPopup();
    }
    if (this.EditStudyUnitflag) {
      this.EditStudyUnitPopup();
    }
    if (this.EditStudyUnitTopicflag) {
      this.EditStudyUnitTopic();
    }
  }

  getsubjectDataRefresh(data: any) {
    this.getsubjectdetails = false;
    // this.Refresh=data;
    let ID: Number = 0;
    if (this.Refresh.dataID != null) {
      ID = Number(this.Refresh.dataID);
    }
    this.ScreenName = this.Activeroute.snapshot.paramMap.get('ScreenName');

    if (this.ScreenName === 'Report') {
      this.getSubjectReport();
    }

    if (!this.studymaterialflag) {
      this.getStudyMaterial(ID);
    }
    let list: any = {};
    // if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='SUBJECT BREAKDOWN'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'SUBJECT BREAKDOWN';
    //   list["childRecordStatus"] = 'ALL';
    // }
    // else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='WIP'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'QUESTION';
    //   list["childRecordStatus"] = 'WIP';
    // }
    // else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Approved'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'QUESTION';
    //   list["childRecordStatus"] = 'Approved';
    // }
    // else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Defer'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'QUESTION';
    //   list["childRecordStatus"] = 'Defer';
    // }
    // else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Rejected'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'QUESTION';
    //   list["childRecordStatus"] = 'Rejected';
    // }
    // else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Rework'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'QUESTION';
    //   list["childRecordStatus"] = 'Rework';
    // }
    // else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Submitted'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'QUESTION';
    //   list["childRecordStatus"] = 'Submitted';
    // }
    // else{

    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'STUDY UNIT';
    //   list["childRecordStatus"] = null;
    // }

    if (this.Activeroute.snapshot.paramMap.get('ScreenName') == 'STUDY UNIT') {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY UNIT';
      list['childRecordStatus'] = 'ALL';
      list['CalledFrom'] = `STUDY UNIT@${this.courseId}` || 'STUDY UNIT';
    } else if (this.Activeroute.snapshot.paramMap.get('ScreenName') == 'WIP') {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'WIP';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Approved'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'Approved';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Defer'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'Defer';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rejected'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'Rejected';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rework'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'Rework';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Under Review'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'Under Review';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Submitted'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'Submitted';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    } else {
      list['currentNodeID'] = ID;
      list['screenName'] = 'STUDY MATERIAL';
      list['childRecordStatus'] = 'ALL';
      list['CalledFrom'] = this.courseId ? `STUDY MATERIAL@${this.courseId}`:'STUDY MATERIAL';
    }

    this.service.getSubjectTree(list).subscribe(
      (i: any) => {
        if (this.Refresh.name == 'MT') {
          this.MajorTopic = i;
          this.subject.forEach((i: { ID: any }) => {
            if (Number(i.ID) === Number(ID)) {
            }
          });
        } else if (this.Refresh.name == 'C') {
          //if(this.MajorTopic[this.Refresh.M].Data !== null)
          this.MajorTopic[this.Refresh.M].Data = i;
          try {
            if (Number(this.MajorTopic[this.Refresh.M].Data.length) > 0) {
              this.MajorTopic[this.Refresh.M].ChildNodeExistInd = 'Y';
            } else {
              this.MajorTopic[this.Refresh.M].ChildNodeExistInd = 'N';
            }
          } catch {}
        } else if (this.Refresh.name == 'SC1') {
          this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data = i;
          try {
            if (
              Number(
                this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data.length
              ) > 0
            ) {
              this.MajorTopic[this.Refresh.M].Data[
                this.Refresh.C
              ].ChildNodeExistInd = 'Y';
            } else {
              this.MajorTopic[this.Refresh.M].Data[
                this.Refresh.C
              ].ChildNodeExistInd = 'N';
            }
          } catch {}
        } else if (this.Refresh.name == 'SC2') {
          this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
            this.Refresh.SC1
          ].Data = i;
          try {
            if (
              Number(
                this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                  this.Refresh.SC1
                ].Data.length
              ) > 0
            ) {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].ChildNodeExistInd = 'Y';
            } else {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].ChildNodeExistInd = 'N';
            }
          } catch {}
        } else if (this.Refresh.name == 'SC3') {
          this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
            this.Refresh.SC1
          ].Data[this.Refresh.SC2].Data = i;
          try {
            if (
              Number(
                this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                  this.Refresh.SC1
                ].Data[this.Refresh.SC2].Data.length
              ) > 0
            ) {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].Data[this.Refresh.SC2].ChildNodeExistInd = 'Y';
            } else {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].Data[this.Refresh.SC2].ChildNodeExistInd = 'N';
            }
          } catch {}
        } else if (this.Refresh.name == 'SC4') {
          this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
            this.Refresh.SC1
          ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data = i;
          try {
            if (
              Number(
                this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                  this.Refresh.SC1
                ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data.length
              ) > 0
            ) {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].Data[this.Refresh.SC2].Data[
                this.Refresh.SC3
              ].ChildNodeExistInd = 'Y';
            } else {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].Data[this.Refresh.SC2].Data[
                this.Refresh.SC3
              ].ChildNodeExistInd = 'N';
            }
          } catch {}
        } else if (this.Refresh.name == 'SC5') {
          this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
            this.Refresh.SC1
          ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[
            this.Refresh.SC4
          ].Data = i;

          try {
            if (
              Number(
                this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                  this.Refresh.SC1
                ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[
                  this.Refresh.SC4
                ].Data.length
              ) > 0
            ) {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[
                this.Refresh.SC4
              ].ChildNodeExistInd = 'Y';
            } else {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[
                this.Refresh.SC4
              ].ChildNodeExistInd = 'N';
            }
          } catch {}
        } else if (this.Refresh.name == 'SC6') {
          this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
            this.Refresh.SC1
          ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[
            this.Refresh.SC4
          ].Data[this.Refresh.SC5].Data = i;
        }
        //   }).catch((e:any)=>{
        //   this.subject=null;
        // }
        // )
      },
      (error) => {
        console.log(error);
      }
    );
  }

  selectedvalue: Number;
  selectedkey: string = '';
  checkstudyunit: boolean = false;
  OnSelect(Value?: Number, d?: any) {
    if (Value == null) {
      return;
    } else if (Number(Value) > 0) {
      this.selectedvalue = Number(Value);
      this.selectedkey = d;
    } else {
      this.selectedvalue = 0;
      this.selectedkey = d;
    }
  }

  checkToEnableAddEdit() {
    if (this.Addnewsubject === true) {
      this.enableedit = true;
    } else if (this.Editsubjectflag === true) {
      this.enableedit = true;
    } else {
      this.enableedit = false;
    }
  }

  mouseoverevent(ID: Number, P1: string, P2?: string): boolean {
    if (
      this.enableedit == true &&
      Number(this.selectedvalue) == ID &&
      (P1 === this.selectedkey || this.selectedkey == P2) &&
      P2 != null
    ) {
      return true;
    } else if (
      this.enableedit == true &&
      Number(this.selectedvalue) == ID &&
      P1 === this.selectedkey
    ) {
      return true;
    } else {
      return false;
    }
  }

  //alert popup

  alertpopup: boolean;
  AlertPopup(data: any) {
    this.alertpopup = !this.alertpopup;
  }

  deletealertpopup: boolean;
  DeleteAlertPopup(data: any) {
    this.deletealertpopup = !this.deletealertpopup;
  }
  deletealertpopup1: boolean;
  DeleteAlertPopup1(data: any) {
    this.deletealertpopup1 = !this.deletealertpopup1;
  }
  replacealertpopup: boolean;
  ReplaceAlertPopup(data: any) {
    this.replacealertpopup = !this.replacealertpopup;
  }
  CloseAlertpopup() {
    if (this.alertpopup) {
      this.AlertPopup(1);
    }

    this.Close.next(1);
  }
  CloseDeleteAlertpopup() {
    if (this.deletealertpopup) {
      this.DeleteAlertPopup(1);
    }

    this.Close1.next(1);
  }
  CloseDeleteAlertpopup1() {
    if (this.deletealertpopup1) {
      this.DeleteAlertPopup1(1);
    }

    this.Closeclear.next(1);
  }
  CloseReplacealertpopup() {
    if (this.replacealertpopup) {
      this.ReplaceAlertPopup(1);
    }
    this.Close.next(1);
  }
  replacebutton() {
    if (this.replacealertpopup) {
      this.ReplaceAlertPopup(1);
    }
    this.Replace.next(1);
  }
  replacedeletebutton() {
    if (this.deletealertpopup) {
      this.DeleteAlertPopup(1);
    }
    this.Replace1.next(1);
    //this.Replace1.complete();
  }
  replacedeletebutton1() {
    if (this.deletealertpopup1) {
      this.DeleteAlertPopup1(1);
    }
    this.Replaceclear.next(1);
  }
  // ngOnDestroy() {
  //   this.Close.unsubscribe();
  //   this.Close1.unsubscribe();
  //   this.Closeclear.unsubscribe();
  //   this.Replace.unsubscribe();
  //   this.Replace1.unsubscribe();
  //   this.Replaceclear.unsubscribe();
  // }

  Contentstatus: any;
  selectedContentById: any;
  Contenttext: string;
  ClickContentstatus(data: any) {
    this.selectedContentById = data.Content;
    this.Contentstatus = data.Content_status;
    this.Contenttext = data.Content_text;
    this.Contentreview();
  }

  Contentreviewpopupflag: boolean;
  Contentreview() {
    this.Contentreviewpopupflag = !this.Contentreviewpopupflag;
  }

  ClkContentclose() {
    if (this.Contentreviewpopupflag) {
      this.Contentreview();
    }
  }
  ReturnContentreviewclose(data: any) {
    this.ClkContentclose();
  }
  EditButton(data: any) {
    this.Editstudymaterial(data);
  }

  statuspopupflag: boolean;
  Selectedstudymaterial: any;
  clickstatuspopup(data: any) {
    this.Selectedstudymaterial = data;
    if (this.ActivityHisotrypopupflag) {
      this.ViewActivityHistory();
    }
    if (this.filtermodelpopup) {
      this.FilterModelpopup();
    }
    if (this.Searchmodelpopup) {
      this.SearchQuestionModel();
    }
    this.statuslistpopup();
  }

  statuslistpopup() {
    this.statuspopupflag = !this.statuspopupflag;
  }

  returnstatusclose(data: any) {
    if (this.statuspopupflag) {
      this.statuslistpopup();
    }
  }
}

interface MajorTopic {
  ChildNodeExistInd: string;
  Study_Unit_Ind: string;
  Data: any;
  Display_Order: Number;
  ID: Number;
  Name: string;
  Parent_Id: Number;
  Status_Code: string;
  Subject_Level_Type_Code: string;
}
